import script from "./DataTableIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataTableIcon.vue?vue&type=script&lang=ts&setup=true"

import "./DataTableIcon.vue?vue&type=style&index=0&id=7c83a7f4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c83a7f4"]])

export default __exports__